import { get, map, without } from 'lodash'

import { isOwnListReducerAction } from 'utils/helpers/store/store'
import {
  DEFAULT_LIST_PAGE,
  FETCH_STATUSES,
  INITIAL_LIST_STATE,
  INITIAL_LIST_META,
} from 'store/common/constants/generic'
import { ACTION_TYPES } from 'store/common/constants/actionsTypes'

export const storeEntityListCreator =
  entityKey =>
  (state = INITIAL_LIST_STATE, action = {}) => {
    const { type, keys = {}, data = {}, meta = {} } = action
    const { exactMatch, first, last, number, numberOfElements, page, size, sort, filters, totalElements, totalPages } =
      meta
    const { id, result, error } = data
    const currentListMeta = get(state, `${keys.list}.meta`, { ...INITIAL_LIST_META })
    const currentListPages = get(state, `${keys.list}.pages`, { [DEFAULT_LIST_PAGE]: [] })

    if (!isOwnListReducerAction(entityKey, keys.entity, keys.list)) {
      return state
    }

    switch (type) {
      case ACTION_TYPES.LIST_FETCH_START: {
        return {
          ...state,
          [keys.list]: {
            meta: {
              ...currentListMeta,
              fetchStatus: FETCH_STATUSES.LOADING,
              fetchStatusError: {},
            },
            pages: {
              ...currentListPages,
            },
          },
        }
      }

      case ACTION_TYPES.LIST_FETCH_SUCCESS: {
        return {
          ...state,
          [keys.list]: {
            meta: {
              ...currentListMeta,
              exactMatch,
              first,
              last,
              number,
              numberOfElements,
              page,
              size,
              sort,
              filters,
              totalElements,
              totalPages,
              fetchStatus: FETCH_STATUSES.LOADED,
              fetchStatusError: {},
            },
            pages: {
              ...currentListPages,
              [page]: get(result, `${entityKey}`, []),
            },
          },
        }
      }

      case ACTION_TYPES.LIST_FETCH_FAIL: {
        return {
          ...state,
          [keys.list]: {
            meta: {
              ...currentListMeta,
              page,
              size,
              sort,
              filters,
              fetchStatus: FETCH_STATUSES.ERROR,
              fetchStatusError: error,
            },
            pages: {
              ...currentListPages,
              [page]: [],
            },
          },
        }
      }

      case ACTION_TYPES.LIST_RESET: {
        return {
          ...state,
          [keys.list]: {
            meta: INITIAL_LIST_META,
            pages: {
              [DEFAULT_LIST_PAGE]: [],
            },
          },
        }
      }

      case ACTION_TYPES.ITEM_REMOVE_SUCCESS: {
        const newPages = {}

        map(currentListPages, (ids, pageId) => {
          newPages[pageId] = without(ids, id)
        })

        return {
          ...state,
          [keys.list]: {
            meta: {
              ...currentListMeta,
            },
            pages: {
              ...newPages,
            },
          },
        }
      }

      default:
        return state
    }
  }
